import Vue from 'vue'
import VueI18n from 'vue-i18n'
import mixin from './mixin'
import messages from './messages'
import axios from 'axios'

Vue.use(VueI18n)
Vue.mixin(mixin)

const locales = Object.keys(messages)
const lang = localStorage.getItem('lang') || navigator.language.split('-')[0]
const locale = locales.includes(lang) ? lang : 'en'

axios.defaults.headers.common['Accept-Language'] = locale
localStorage.setItem('lang', locale)

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n
